var $ = require('jquery');

$(function () {
    $('.ws-article__featured-article-card').focus(function () {
        if (!$("body").hasClass("ws-click"))
        {
            $(this).parent('.ws-article__featured-article').css({
                'outline': '2px dotted #095586',
                'outline-offset': '5px'
            }).focusout(
                function () {
                    $(this).css({
                        'outline': '',
                        'outline-offset': ''
                    });
                });
        }
    });
});